/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  constructor() { }

  set(key: string, value: any): void {
      localStorage.setItem(key, JSON.stringify(value));
  }

  get(key: string):any {
    const value = localStorage.getItem(key);
      if (value) {
        return JSON.parse(value);
      }
    return null;
  }
  remove(key: any): void {
    localStorage.removeItem(key);
  }
}
